import { render, staticRenderFns } from "./MaterialDispatch.vue?vue&type=template&id=313c60ea&scoped=true&"
import script from "./MaterialDispatch.vue?vue&type=script&lang=js&"
export * from "./MaterialDispatch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "313c60ea",
  null
  
)

export default component.exports